var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResize = function SvgResize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    d: "m5.645 7.646 2-2M.645 7.646l7-7"
  })));
};
export default SvgResize;